module.exports = __webpack_public_path__ + "static/media/membership2026-adult.58ffda50.png";